export const WEBHOOK_CATEGORIES = {
  SUBMISSIONS: 'submissions',
  ENGAGEMENT: 'engagement',
};

// Maps EventType -> API field name in the `webhook` object
export const WEBHOOK_EVENTS = [
  // === SUBMISSIONS (26) ===
  { key: 'isHeaderSubscribe', eventType: 'SubmitHeaderSubscribe', category: WEBHOOK_CATEGORIES.SUBMISSIONS },
  { key: 'isHeaderMessage', eventType: 'SubmitHeaderMessage', category: WEBHOOK_CATEGORIES.SUBMISSIONS },
  { key: 'isEmailSubmit', eventType: 'SubmitDataCollect', category: WEBHOOK_CATEGORIES.SUBMISSIONS },
  { key: 'isFormSubmit', eventType: 'SubmitForm', category: WEBHOOK_CATEGORIES.SUBMISSIONS },
  { key: 'isCartSubmit', eventType: 'SubmitShop', category: WEBHOOK_CATEGORIES.SUBMISSIONS },
  { key: 'isShopPreorder', eventType: 'SubmitShopPreorder', category: WEBHOOK_CATEGORIES.SUBMISSIONS },
  { key: 'isDigitalSubmit', eventType: 'SubmitDigital', category: WEBHOOK_CATEGORIES.SUBMISSIONS },
  { key: 'isAppointmentSubmit', eventType: 'SubmitAppointment', category: WEBHOOK_CATEGORIES.SUBMISSIONS },
  { key: 'isRequestSubmit', eventType: 'SubmitService', category: WEBHOOK_CATEGORIES.SUBMISSIONS },
  { key: 'isEventSubmit', eventType: 'SubmitEvent', category: WEBHOOK_CATEGORIES.SUBMISSIONS },
  { key: 'isCourseSubmit', eventType: 'SubmitCourse', category: WEBHOOK_CATEGORIES.SUBMISSIONS },
  { key: 'isDonationSubmit', eventType: 'SubmitDonation', category: WEBHOOK_CATEGORIES.SUBMISSIONS },
  { key: 'isMembershipSubmit', eventType: 'SubmitMembership', category: WEBHOOK_CATEGORIES.SUBMISSIONS },
  { key: 'isBlogSubmit', eventType: 'SubmitBlog', category: WEBHOOK_CATEGORIES.SUBMISSIONS },
  { key: 'isCouponSubmit', eventType: 'SubmitCoupon', category: WEBHOOK_CATEGORIES.SUBMISSIONS },
  { key: 'isTipSubmit', eventType: 'SubmitTip', category: WEBHOOK_CATEGORIES.SUBMISSIONS },
  { key: 'isLinkSubmit', eventType: 'SubmitLink', category: WEBHOOK_CATEGORIES.SUBMISSIONS },
  { key: 'isProductMessage', eventType: 'SubmitProductMessage', category: WEBHOOK_CATEGORIES.SUBMISSIONS },
  { key: 'isPodcastSubmit', eventType: 'SubmitPodcast', category: WEBHOOK_CATEGORIES.SUBMISSIONS },
  { key: 'isBookingSubmit', eventType: 'SubmitBooking', category: WEBHOOK_CATEGORIES.SUBMISSIONS },
  { key: 'isRentalSubmit', eventType: 'SubmitRental', category: WEBHOOK_CATEGORIES.SUBMISSIONS },
  { key: 'isSingleProduct', eventType: 'SubmitSingleProduct', category: WEBHOOK_CATEGORIES.SUBMISSIONS },
  { key: 'isDiscountOrder', eventType: 'SubmitDiscount', category: WEBHOOK_CATEGORIES.SUBMISSIONS },
  { key: 'isListingRequest', eventType: 'SubmitListing', category: WEBHOOK_CATEGORIES.SUBMISSIONS },
  { key: 'isContentUnlock', eventType: 'SubmitUnlock', category: WEBHOOK_CATEGORIES.SUBMISSIONS },
  { key: 'isChatAi', eventType: 'SubmitChatAi', category: WEBHOOK_CATEGORIES.SUBMISSIONS },

  // === ENGAGEMENT (12) ===
  { key: 'isLinkClick', eventType: 'ClickLink', category: WEBHOOK_CATEGORIES.ENGAGEMENT },
  { key: 'isContactClick', eventType: 'ClickContact', category: WEBHOOK_CATEGORIES.ENGAGEMENT },
  { key: 'isCartAdd', eventType: 'AddToCart', category: WEBHOOK_CATEGORIES.ENGAGEMENT },
  { key: 'isSingleProductToCart', eventType: 'AddToCartSingleProduct', category: WEBHOOK_CATEGORIES.ENGAGEMENT },
  { key: 'isWishlist', eventType: 'AddToWishlist', category: WEBHOOK_CATEGORIES.ENGAGEMENT },
  { key: 'isInitiateCheckout', eventType: 'InitiateCheckout', category: WEBHOOK_CATEGORIES.ENGAGEMENT },
  { key: 'isFileDownload', eventType: 'DownloadFile', category: WEBHOOK_CATEGORIES.ENGAGEMENT },
  { key: 'isMusicDownload', eventType: 'DownloadMusic', category: WEBHOOK_CATEGORIES.ENGAGEMENT },
  { key: 'isCopyCoupon', eventType: 'CopyCoupon', category: WEBHOOK_CATEGORIES.ENGAGEMENT },
  { key: 'isCopyDiscount', eventType: 'CopyDiscount', category: WEBHOOK_CATEGORIES.ENGAGEMENT },
  { key: 'isQrCodeScan', eventType: 'QR_ScanQrCode', category: WEBHOOK_CATEGORIES.ENGAGEMENT },
  { key: 'isPageVisit', eventType: 'VisitPage', category: WEBHOOK_CATEGORIES.ENGAGEMENT },
];

export const TOTAL_EVENTS = WEBHOOK_EVENTS.length;

export const SUBMISSIONS_EVENTS = WEBHOOK_EVENTS.filter((e) => e.category === WEBHOOK_CATEGORIES.SUBMISSIONS);
export const ENGAGEMENT_EVENTS = WEBHOOK_EVENTS.filter((e) => e.category === WEBHOOK_CATEGORIES.ENGAGEMENT);

// Build default webhookEvents object (all false)
export const DEFAULT_WEBHOOK_EVENTS = WEBHOOK_EVENTS.reduce((acc, event) => {
  acc[event.key] = false;
  return acc;
}, {});
